import { Injectable } from '@angular/core';
import { ObligationForm } from '../../data/system/obligation';

@Injectable()
export class ObligationStatusUtilService {

    public obligation_status: Array<any> = [];
    public date: any | undefined = undefined;

    public getObligationStatus(obligation: ObligationForm | any, date: any | undefined = undefined) {
        console.log(`obligation`, obligation);

        if (date != undefined) {
            this.date = date;
        }

        const fund_source = obligation.fund_source;
        const initObligationAmount = this.getObligationAmount(fund_source);
        const initAdjustedObligationAmount = this.getAdjustedObligationAmount(fund_source);
        let orsAmount = 0;
        let dueDemandable = 0;
        let orsStatusAmount = initObligationAmount;
        let orsPaymentAmount = initAdjustedObligationAmount;

        this.obligation_status = [];
        // let accounts = fund_source.map((a: any) => a.account);
        fund_source.forEach((fnd_src: any) => {
            fnd_src.account.forEach((acct: any) => {
                // set obligation functions
                acct.function.forEach((funct: any) => {
                    // const stat_payable = 0;
                    // const stat_payment = 0;
                    orsAmount += Number(funct.of_amount);
                    this.obligation_status.push({
                        type: "ors",
                        date: obligation.or_date,
                        // fnd_name: fnd_src.ofs_fund_name,
                        // fnd_code: fnd_src.ofs_fund_sysref_code,
                        acct_name: `${acct.oa_acct_name}`,
                        uacs_code: acct.oa_uacs_code,
                        sysref_code: acct.oa_sysref_code,
                        obligation: Number(funct.of_amount),
                        payable: 0,
                        payment: 0,
                        savings: 0,
                        not_yet_due: orsAmount,
                        due_and_demandable: 0,
                        remarks: obligation.or_number
                    });

                    // set status
                    funct.status?.forEach((st: any) => {
                        if (st.os_remarks != "") {
                            const savings = Number(st.os_savings)
                            // const savings = (Number(st.os_obligation) - Number(st.os_payable));
                            // if (savings > 0 || Number(st.os_obligation) < 0) {
                            if (savings > 0 || Number(st.os_obligation) < 0) {
                                // orsStatusAmount += (savings * -1);
                                this.obligation_status.push({
                                    type: "status",
                                    date: st.os_date,
                                    // fnd_name: fnd_src.ofs_fund_name,
                                    // fnd_code: fnd_src.ofs_fund_sysref_code,
                                    acct_name: acct.oa_acct_name,
                                    uacs_code: acct.oa_uacs_code,
                                    sysref_code: acct.oa_sysref_code,
                                    obligation: (Number(st.os_payable) < 0) ? Number(st.os_obligation) : (savings * -1),
                                    payable: (Number(st.os_payable) < 0) ? Number(st.os_payable) : 0,
                                    payment: (Number(st.os_payable) < 0) ? Number(st.os_payable) : 0,
                                    // obligation: (savings * -1),
                                    // payable: 0,
                                    // payment: 0,
                                    savings: savings,
                                    // not_yet_due: (Number(st.os_obligation) < 0) ? 0 : orsStatusAmount,
                                    // not_yet_due: orsStatusAmount,
                                    not_yet_due: 0,
                                    // due_and_demandable: (Number(st.os_obligation) < 0) ? 0 : Number(st.os_payable),
                                    due_and_demandable: 0,
                                    remarks: st.os_remarks
                                });
                            }
                        }

                        // set payments
                        this.sortByDate(st.details, 'ospp_date').forEach((payments: any) => {
                            let payable = (Number(payments.ospp_payable) === Number(st.os_payable)) ? Number(st.os_payable) : 0;
                            let payment = Number(payments.ospp_payment);
                            // dueDemandable = Number(Number((Number(dueDemandable.toFixed(2)) + Number(payable.toFixed(2))) - Number(payment.toFixed(2))).toFixed(2));
                            // orsPaymentAmount -= payable;
                            this.obligation_status.push({
                                type: 'payment',
                                date: payments.ospp_date,
                                // fnd_name: "",
                                // fnd_code: fnd_src.ofs_fund_sysref_code,
                                acct_name: acct.oa_acct_name,
                                uacs_code: acct.oa_uacs_code,
                                sysref_code: acct.oa_sysref_code,
                                obligation: 0,
                                payable: payable,
                                payment: payment,
                                savings: Number(payments.ospp_savings),
                                // not_yet_due: orsPaymentAmount,
                                not_yet_due: 0,
                                // due_and_demandable: Number(payments.ospp_payable) - Number(payments.ospp_payment),
                                // due_and_demandable: dueDemandable,
                                due_and_demandable: 0,
                                remarks: payments.ospp_remarks
                            });
                        });
                    });
                });
            });
        });

        console.log(`obligation_status`, this.obligation_status);
        this.obligation_status.sort((a: any, b: any) => (new Date(a.date) as any) - (new Date(b.date) as any));

        this.obligation_status.forEach((status: any) => {
            if (status.type === "status" && status.payable >= 0) {
                orsStatusAmount += (status.savings * -1);
                status.not_yet_due = orsStatusAmount;
            }
            if (status.type === "payment") {
                orsPaymentAmount -= Number(status.payable.toFixed(2));
                status.not_yet_due = orsPaymentAmount;
                dueDemandable = Number(((dueDemandable + status.payable) - status.payment).toFixed(2));
                status.due_and_demandable = dueDemandable;
            }
        });

        return this.obligation_status;
    }

    public getSumOfArrayObjectProperty(arrObj: Array<any>, prop: string) {
        let sum = 0;
        arrObj.forEach((ao: any) => {
            if (Number(ao[prop])) {
                sum += Number(ao[prop]);
            }
        });
        return sum;
    }

    // public setNotYetDue(ors: Array<any>) {
    //     // let ors_count = 0;
    //     // ors.forEach((status: any, index) => {
    //     //     // if (status.type == "ors" && ors_count > 0) {
    //     //     //     status.not_yet_due = Number((Number(ors[index - 1].not_yet_due) + Number(status.obligation)).toFixed(2));
    //     //     //     status.due_and_demandable = (Number(ors[index - 1].due_and_demandable) + (Number(status.payable)) - Number(status.payment));
    //     //     // }
    //     //     // if (status.type == "ors") ors_count++;

    //     //     // if (status.type == "status") {
    //     //     //     //     let prevNotYetDue = Number(ors[index - 1].not_yet_due);
    //     //     //     //     status.not_yet_due = Number((Number((prevNotYetDue - Number(status.savings)).toFixed(2)) - Number(status.payable)).toFixed(2));
    //     //     //     status.due_and_demandable = 0;
    //     //     // }

    //     //     // if (status.type == "payment") {
    //     //     //     if (Number(status.payable) == 0) {
    //     //     //         status.not_yet_due = 0;
    //     //     //         status.due_and_demandable = 0;
    //     //     //         // let prevNotYetDue = Number(ors[index - 1].not_yet_due);
    //     //     //         // status.not_yet_due = Number((Number((prevNotYetDue + Number(status.obligation)).toFixed(2)) - Number(status.payable)).toFixed(2));
    //     //     //         // status.due_and_demandable = (Number(ors[index - 1].due_and_demandable) + (Number(status.payable)) - Number(status.payment));
    //     //     //     }
    //     //     // }
    //     // });
    //     return ors;
    // }

    public getObligationAmount(fund_source: Array<any>) {
        let amount = 0;
        fund_source.forEach((fnd_src: any) =>
            fnd_src.account.forEach((acct: any) =>
                acct.function.forEach((funct: any) => {
                    amount += Number(funct.of_amount);
                    // funct.status.forEach((st: any) => {
                    //     amount += Number(st.os_payable ?? 0);
                    //     // savings.push(Number(st.os_savings));
                    // });
                })
            )
        );
        return amount;
    }

    public getAdjustedObligationAmount(fund_source: Array<any>) {
        let amount = 0;
        fund_source?.forEach((fnd_src: any) => {
            fnd_src.account?.forEach((acct: any) => {
                acct.function?.forEach((funct: any) => {
                    amount += Number(funct.of_amount);
                    funct?.status?.forEach((st: any) => {
                        // amount -= Number(st.os_savings);
                        amount -= (Number(st.os_obligation) < 0) ? Math.abs(Number(st.os_obligation)) : Number(st.os_savings);
                        // let savings = Number(st.os_savings);
                        // if (savings > 0) {
                        //     amount -= savings;
                        // }
                    });
                })
            })
        });
        return amount;
    }

    // private getPreviousNotYetDue() {
    //     const orsLength = this.obligation_status.length;
    //     return (orsLength > 0) ? Number(this.obligation_status[orsLength - 1].not_yet_due) : 0;
    // }

    public sortByDate(array: Array<any>, date: string) {
        return array.sort((a, b) => {
            const dateA = new Date(a[date]).getTime();
            const dateB = new Date(b[date]).getTime();
            return dateA - dateB;
        });
    }

    public sortById(array: Array<any>, id: string | number) {
        return array.sort((a, b) => {
            return Number(a[id]) - Number(b[id]);
        });
    }

    // private getObligationStatusPayableAndPayment(fund_source: Array<any>) {
    //     let status = fund_source.map((fsource: any) => {
    //         return fsource.account.map((acct: any) => {
    //             return acct.function.map((fn: any) => {
    //                 return fn.status.map((stat) => stat.details);
    //             });
    //         });
    //     });
    //     console.log(`status`, status);

    //     let status_collection = [];
    //     status.forEach((fsource: any) => {
    //         fsource.forEach((acct: any) => {
    //             acct.forEach((fn: any) => {
    //                 fn.forEach((stat: any) => {
    //                     stat.forEach((details: any) => {
    //                         status_collection.push(details);
    //                     });
    //                 });
    //             });
    //         });
    //     });
    //     console.log(`status_collection`, status_collection.sort((a: any, b: any) => Number(new Date(a.ospp_date)) - Number(b.ospp_date)));

    //     let d = [];
    //     let stat_collection_temp = JSON.parse(JSON.stringify(status_collection));

    //     while (stat_collection_temp.length > 0) {
    //         // let ref = stat_collection_temp[0].ospp_remarks.substring(stat_collection_temp[0].ospp_remarks.length - 7);
    //         // let stat_data = status_collection.filter((sf: any) => sf.ospp_remarks.substring(sf.ospp_remarks.length - 7) == ref);
    //         let ref = stat_collection_temp[0].ospp_remarks.split(" ")[stat_collection_temp[0].ospp_remarks.split(" ").length - 1];
    //         let stat_data = status_collection.filter((sf: any) => sf.ospp_remarks.split(" ")[sf.ospp_remarks.split(" ").length - 1] == ref);
    //         d.push(stat_data);
    //         stat_collection_temp.splice(0, 1);
    //         if (stat_data.length > 1) {
    //             // let index = stat_collection_temp.findIndex((item) => item.ospp_remarks.substring(item.ospp_remarks.length - 7) == ref);
    //             let index = stat_collection_temp.findIndex((item) => item.ospp_remarks.split(" ")[item.ospp_remarks.split(" ").length - 1] == ref);
    //             stat_collection_temp.splice(index, 1);
    //         }
    //     }

    //     console.log(`d_data`, d);
    //     let refined_data = [];
    //     d.forEach((d: Array<any>) => {
    //         if (d.length == 1) {
    //             refined_data.push(d[0]);
    //         }
    //         if (d.length > 1) {
    //             let d_tmp = {
    //                 ospp_id: 0,
    //                 os_id: 0,
    //                 payee_id: 0,
    //                 payee_name: "",
    //                 ospp_payable: 0,
    //                 ospp_payment: 0,
    //                 ospp_remarks: "",
    //                 ospp_date: ""
    //             };
    //             d.forEach((dData: any) => {
    //                 d_tmp.payee_id = dData.payee_id;
    //                 d_tmp.payee_name = dData.payee_name;
    //                 d_tmp.ospp_payable = this.getSumOfArrayObjectProperty(d, 'ospp_payable');
    //                 d_tmp.ospp_payment = this.getSumOfArrayObjectProperty(d, 'ospp_payment');
    //                 d_tmp.ospp_remarks = dData.ospp_remarks;
    //                 d_tmp.ospp_date = dData.ospp_date;
    //             });
    //             refined_data.push(d_tmp);
    //         }
    //     });
    //     console.log(`refined_data`, refined_data);

    //     let prev_due_and_demandable = Number(this.obligation_status[this.obligation_status.length - 1].due_and_demandable);
    //     let prev_not_yet_due = Number(this.obligation_status[this.obligation_status.length - 1].not_yet_due);
    //     refined_data.sort((a: any, b: any) => Number(new Date(a.ospp_date)) - Number(new Date(b.ospp_date))).forEach((sc: any) => {
    //         let stat = {
    //             date: sc.ospp_date,
    //             fnd_name: "",
    //             fnd_code: "",
    //             acct_name: "",
    //             uacs_code: "",
    //             sysref_code: "",
    //             obligation: 0,
    //             payable: Number(sc.ospp_payable),
    //             payment: Number(sc.ospp_payment),
    //             savings: 0,
    //             not_yet_due: (Number(sc.ospp_payable) > 0) ? prev_not_yet_due - Number(sc.ospp_payable) : 0,
    //             due_and_demandable: (Number(sc.ospp_payable) - Number(sc.ospp_payment)) + prev_due_and_demandable,
    //             remarks: sc.ospp_remarks
    //         };
    //         this.obligation_status.push(stat);
    //         prev_not_yet_due = stat.not_yet_due;
    //         prev_due_and_demandable = stat.due_and_demandable;
    //     });

    //     if (this.date != undefined) {
    //         if (this.date != "") {
    //             this.filterByDate();
    //         }
    //     }
    // }

    // private filterByDate() {
    //     let os = JSON.parse(JSON.stringify(this.obligation_status));
    //     this.obligation_status = os.filter((o: any) => ((new Date(this.date).getTime() - new Date(o.date).getTime()) >= 0) ? true : false)
    // }

}
